import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Typography,
  Box,
} from '@mui/material';

import useStyles from './styles';

function Header(
  {
    competence,
    score,
  }: {
    competence: string,
    score: number,
  },
) {
  const classes = useStyles();

  return (
    <Container className={classes.titleContainer}>
      <Box>
        <Typography
          variant="h4"
          className={classes.testName}
        >
          {competence}
        </Typography>
        <Typography
          variant="body1"
          className={classes.testName}
        >
          Ensayo contestado
        </Typography>
        <Typography
          variant="h4"
          className={classes.testScore}
        >
          Puntaje: {score}
        </Typography>
      </Box>
    </Container>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
